import axios from "axios";
import { backendUrl, errorSweetAlert } from "../helpers/constants";
import store from "../redux/store";
import { logout } from "../redux/slices/authSlice";

const axiosConfig = axios.create({
  baseURL: backendUrl,
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosConfig.interceptors.request.use(
  (config) => {
    const { token } = store.getState().auth;

    config.headers.Authorization = `Bearer ${token || ""}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const notAuthorizedMessages = [
  "Access denied, you're not login",
  "Access denied, user not found",
  "Access denied, invalid token",
  "Role not found for the user",
  "User doesn't have permission to this route",
  "User not found",
  "Authentication token missing",
  "Merchant does not exist",
  "SubMerchant does not exist",
  "Invalid or expired token"
];

axiosConfig.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response) {
      // console.error(
      //   "Response error:",
      //   error.response.status,
      //   error.response.data
      // );

      if (
        notAuthorizedMessages.includes(
          error.response?.data?.message?.message ||
            error.response?.data?.message
        )
      ) {
        store.dispatch(logout());
        errorSweetAlert(
          // error.response?.data?.message?.message ||
          //   error.response?.data?.message ||
            "Session expired. Please login again."
        );
        setTimeout(() => {
          window.location.href = "/";
        }, [500]);
      }
    } else if (error.request) {
      console.error("Request error:", error.request);
    } else {
      console.error("Error:", error.message);
    }
    return Promise.reject({
      ...error,
      response: {
        ...error?.response,
        data: {
          ...error.response?.data,
          message: error?.response?.data?.message?.message
            ? error?.response?.data?.message?.message
            : error?.response?.data?.message ||
              "Server error: please contact system admin",
        },
      },
    });
  }
);

export default axiosConfig;
